import { NgModule } from '@angular/core';
import { RegisterComponent } from './register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbAlertModule,
  NbCardModule,
  NbIconModule,
  NbCheckboxModule,
  NbButtonModule,
  NbInputModule,
  NbStepperModule,
  NbRouteTabsetModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { ThemeModule } from '../../@theme/theme.module';
import { IscanCommmonModule } from '../../common/common.module';

@NgModule({
  imports: [
    NbCardModule,
    NbAlertModule,
    NbIconModule,
    NbCheckboxModule,
    NbButtonModule,
    NbInputModule,
    NbStepperModule,
    NbSpinnerModule,
    ReactiveFormsModule,
    IscanCommmonModule,

    RouterModule,
    FormsModule,
    ThemeModule,
  ],
  declarations: [RegisterComponent],
})
export class RegisterModule {}
